module.exports = __webpack_public_path__ + "media/Loops 110 Keys.af7912f7.wav";